import { ValidationErrors } from '@/ui/features/background-check/components/background-check-modal/components/BackgroundCheckAccountDetails';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import { TFunction } from 'i18next';
import get from 'lodash/get';

interface GetErrorFieldsLabelsProps {
    account: AccountData;
    accountDetailsFields: { key: string; label: string }[];
    validationErrors: ValidationErrors;
    t: TFunction<'rms'>;
}

export function getErrorFieldsLabels({ account, accountDetailsFields, validationErrors, t }: GetErrorFieldsLabelsProps) {
    const errorFieldsLabels = accountDetailsFields.reduce((acc: string[], { key, label }) => {
        const error = !!get(validationErrors, key)?._errors?.[0];
        if (error) {
            acc.push(label);
        }
        return acc;
    }, []);

    if (!account?.consentBackgroundCheck) {
        errorFieldsLabels.push(t('backgroundCheck.labels.backgroundCheckConsent'));
    }

    return errorFieldsLabels;
}
